const getSeo = page => {
	if (!page.seo) {
		return {};
	}
	return {
		title: page.seo.ogText,
		description: page.seo.ogDescription,
		image: page.seo.ogImage.file.url
	};
};

export default getSeo;
